<div class="card-size">

  <div class="row">
    <div class="col-md-6">
      <div class="row ">
        <div class="col-md-12">
          <!-- FORMULAIRE POINT DE LIVRAISON -->
          <div class="card">
            <div class="card-header">
              <h3 class="first">INFOS PRINCIPALES</h3>
            </div>
            <div class="card-body">
              <form [formGroup]="formPointDeLivraison">
                <ng-container *ngFor="let field of fieldsPointDeLivraison">
                  <yo-dynamic-form-field-bs [form]="formPointDeLivraison" [field]="field"
                                            [fields]="fieldsPointDeLivraison"></yo-dynamic-form-field-bs>
                </ng-container>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="row mg-t-10">
        <div class="col-md-12">
          <!--              FORMULAIRE ADRESSE-->
          <div class="card">
            <div class="card-header">
              <h3 class="first">ADRESSE</h3>
            </div>
            <div class="card-body">
              <form [formGroup]="formAdressePdl">
                <ng-container *ngFor="let field of fieldsAdressePdl">
                  <yo-dynamic-form-field-bs [form]="formAdressePdl" [field]="field"
                                            [fields]="fieldsAdressePdl"></yo-dynamic-form-field-bs>
                </ng-container>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="row mg-t-10">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h3 class="first">FRAIS FIXE AU SERVICE</h3>
            </div>
            <div class="card-body">
              <div class="dialog-line">
                <div class="label">Frais fixe</div>
                <div class="value">
                  <dx-select-box
                    [dataSource]="fraisFixeAuServiceResource.value() ?? []"
                    [value]="selectedFraisFixeId()"
                    displayExpr="libelle"
                    valueExpr="id"
                    [showClearButton]="true"
                    placeholder="Sélectionner un frais fixe..."
                    [disabled]="!gds.canModify(client)"
                    (onValueChanged)="selectedFraisFixeId.set($event.value)">
                  </dx-select-box>
                </div>
              </div>
              <div class="dialog-line">
                <div class="label">Fréquence d'application /mois</div>
                <div class="value">
                  <dx-number-box
                    [value]="fraisFixeFrequence()"
                    [min]="0"
                    [showClearButton]="true"
                    placeholder="Fréquence /mois"
                    [disabled]="!gds.canModify(client)"
                    (onValueChanged)="fraisFixeFrequence.set($event.value)">
                  </dx-number-box>
                </div>
              </div>
              <div class="dialog-line">
                <div class="label">Montant HT</div>
                <div class="value">
                  <dx-number-box
                    [value]="fraisFixeMontantHT()"
                    [min]="0"
                    [showClearButton]="true"
                    placeholder="Montant HT"
                    [disabled]="!gds.canModify(client)"
                    (onValueChanged)="fraisFixeMontantHT.set($event.value)">
                  </dx-number-box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>


    <div class="col-md-6">

      <div class="row ">
        <div class="col-md-12">
          <!--              FORMULAIRE CONTACT 1-->
          <div class="card">
            <div class="card-header">
              <h3 class="first">Contact 1</h3>
            </div>
            <div class="card-body">
              <form [formGroup]="formContact1">
                <ng-container *ngFor="let field of fieldsContact1">
                  <yo-dynamic-form-field-bs [form]="formContact1" [field]="field"
                                            [fields]="fieldsContact1"></yo-dynamic-form-field-bs>
                </ng-container>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="row mg-t-10">
        <div class="col-md-12">
          <!--              FORMULAIRE CONTACT 2-->
          <div class="card">
            <div class="card-header">
              <h3 class="first">Contact 2</h3>
            </div>
            <div class="card-body">
              <form [formGroup]="formContact1">
                <ng-container *ngFor="let field of fieldsContact2">
                  <yo-dynamic-form-field-bs [form]="formContact2" [field]="field"
                                            [fields]="fieldsContact2"></yo-dynamic-form-field-bs>
                </ng-container>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="d-flex justify-content-end mg-t-15">
        <span class="mg-r-5">
            <yo-button
                    tooltip="Enregistrer"
                    type="submit"
                    iconClass="fas fa-save"
                    [theme]="ButtonThemeEnum.SAVE"
                    (onClick)="save()"
                    [disabled]="!gds.canModify(client)">
            </yo-button>
        </span>
</div>



